const state = {
	avatar: '', // 头像
	birth: '', // 生日
	companyName: '',
	companyPosition: '', // 公司职务
	isRegister: null,
	token: '',
	userId: null,
	userName: '', // 用户姓名
	defaultUserName: null,
	vipLevel: 0, // vip等级 0 普通用户 1 vip
	vipStartDate: '', // vip开始时间
	vipEndDate: '',  // vip结束时间
	availableCouponNum: 0, // 可用优惠券张数
	notAvailableCouponNum: 0, // 不可用优惠券
	formattedMobile: "", // 带*手机号
	policyExpertLeftTimes: 0, // 专家咨询剩余次数
	policyLeftVisitTimes: 0, // 政策剩余查看次数 -1表示不限制
	policyRemind: 0, // app设置是否接受政策提醒 1是 0否
	policySecretary: 0, // 政策提醒 1是 0否
	policySecretaryNum: 0, // 小秘书新增次数
	unReadMsgNum: 0,  // 未读信息数
	policyExpertOnline: 0, // 专家是否在线1：在线  0 不在线
	vipEndTime: null, // 会员兑换码兑换到期时间
	companyStartPage: null, // 是否需要企业引导页 1-是 0-否
	vipStartTime: null, // 会员开始时间
	timeLenStr: null,  // 会员兑换码新增天数
	noVipPolicyDayVisitTimes: 0,  // 非会员每天可查看政策数量
	hasVIPLevelForNewUserName: null, //	新BOOS专享套餐名称 没有时返回NULL
	hasVIPLevelForNewUserPrice: 0, //	新BOOS专享套餐价格
	messageList: [],
	companyMaterialCompleteRate: null,
	vipLeftDays: null,
	companyProvinceId: null,
	companyProvinceName: null,
	companyCityId: null,
	companyCityName: null,
}

export default state
